import React from 'react';
import { Table, Empty, Button, Input, Form, Select, DatePicker, Icon } from 'antd';
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';

const { Option } = Select;
export default function CierreDolares(props) {

    return (
        <div>
            <Table
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.id}
                locale={{
                    emptyText:
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='No se encontraron datos'
                        />
                }}
                columns={[
                    {
                        title: 'Tipo',
                        dataIndex: 'formato',
                        key: 'formato',
                        align: 'center'
                    },
                    {
                        title: 'Denominación',
                        dataIndex: 'abreviatura',
                        key: 'abreviatura',
                        render: function(value,row) {
                         return (
                            <div>
                            {value}{row.monto}
                        </div>
                         )

                        }
                    },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecioCantidadDolares[${row.id}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            disabled={props.precioUnitarioDisabled}
                                            placeholder="Cantidad"
                                            autoComplete="off"
                                            className="text-right"
                                            //onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => props.handleCalculateDolar(row, "arrPrecioUnitario", e.target.value, 5)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                
                    },
        
                 
                    {
                        title: 'Monto',
                        dataIndex: 'total',
                        key: 'total',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )

                    },
          

                ]}
            />
        </div>
    );
}